export interface OrganizationOverviewItemDto {
  id: string;
  name: string;
  salesOwner: string;
  dealsCount: number;
  buyerSeatsCount: number;
  email: string;
  phone: string;
  status: string;
}

export interface PageMetaDto {
  pageNumber: number;
  limit: number;
  prevCursor?: string;
  nextCursor?: string;
  currentAction?: string;
}

export interface OrganizationsOverviewResponseDto {
  organizations: OrganizationOverviewItemDto[];
  meta: PageMetaDto;
}

export enum ORG_STATUS {
  ACTIVE = 'CWIRE_ORGANIZATION_ACTIVE',
  INACTIVE = 'CWIRE_ORGANIZATION_INACTIVE',
  DRAFT = 'CWIRE_ORGANIZATION_DRAFT',
}